import { render, staticRenderFns } from "./ImgDragSort.vue?vue&type=template&id=51f763d5&scoped=true"
import script from "./ImgDragSort.vue?vue&type=script&lang=js"
export * from "./ImgDragSort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f763d5",
  null
  
)

export default component.exports